import { render, staticRenderFns } from "./CollapsibleContent.vue?vue&type=template&id=a1193936&scoped=true&"
import script from "./CollapsibleContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CollapsibleContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CollapsibleContent.vue?vue&type=style&index=0&id=a1193936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1193936",
  null
  
)

export default component.exports